import { render, staticRenderFns } from "./HodRegistrationPage.vue?vue&type=template&id=48f34318&scoped=true&"
import script from "./HodRegistrationPage.vue?vue&type=script&lang=ts&"
export * from "./HodRegistrationPage.vue?vue&type=script&lang=ts&"
import style0 from "./HodRegistrationPage.vue?vue&type=style&index=0&id=48f34318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f34318",
  null
  
)

export default component.exports